module.exports = __webpack_public_path__ + "static/media/display01.0aca8693.jpg";